import React from 'react';
import './MaterialPagination.css';

interface MaterialPaginationProps {
  page: number;
  totalPages: number;
  totalCount?: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

const MaterialPagination: React.FC<MaterialPaginationProps> = ({
  page,
  totalPages,
  totalCount,
  onPageChange,
  disabled,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="material-pagination">
      {totalCount != null && (
        <span className="material-pagination-count">{totalCount} item(s)</span>
      )}
      <button
        type="button"
        className="material-pagination-btn"
        disabled={disabled || page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </button>
      <span className="material-pagination-label">
        Page {page} of {totalPages}
      </span>
      <button
        type="button"
        className="material-pagination-btn"
        disabled={disabled || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default MaterialPagination;
